import { Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'gbc-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    imports: [NgClass]
})
export class BannerComponent {
  @Input() type: 'info' | 'alarm' | 'warning' | 'success';
  @Input() class: string;
}
